import { render, staticRenderFns } from "./InputGroupIngredientsGroup.vue?vue&type=template&id=5e777d3c"
import script from "./InputGroupIngredientsGroup.vue?vue&type=script&lang=js"
export * from "./InputGroupIngredientsGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports